// extracted by mini-css-extract-plugin
export var legendIndicator = "_es-1";
export var legendRight = "_es-0";